import { employeesUrl } from 'router/url';
import { fetchWithAuthorization } from 'utils/authorizedFetch';
import {
  ApiResult,
  EmploymentAccountOption,
  EmploymentForm,
  EmploymentFormUpdate,
} from './types';

const readResponse = async <T>(response: Response): Promise<ApiResult<T>> => {
  const text = await response.text();
  let data: T | undefined;
  let message: string | undefined;

  if (text) {
    try {
      const parsed = JSON.parse(text);
      data = parsed;
      message = parsed?.errorMessage || parsed?.message;
    } catch {
      message = response.ok ? undefined : response.statusText;
    }
  }

  return { ok: response.ok, status: response.status, data, message };
};

const request = async <T>(
  url: string,
  init?: RequestInit,
): Promise<ApiResult<T>> => {
  try {
    return readResponse<T>(await fetchWithAuthorization(url, init));
  } catch (error) {
    return { ok: false, status: 0, message: (error as Error).message };
  }
};

export const employmentFormUrl = (username: string) =>
  `/api/accounts/${encodeURIComponent(username)}/employment-form`;

export const fetchEmploymentAccounts = () =>
  request<EmploymentAccountOption[]>(employeesUrl);

export const fetchEmploymentForm = (username: string) =>
  request<EmploymentForm>(employmentFormUrl(username));

export const updateEmploymentForm = (
  username: string,
  update: EmploymentFormUpdate,
) =>
  request<EmploymentForm>(employmentFormUrl(username), {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(update),
  });
